export default __webpack_public_path__ + "static/media/stencils.7225ae37.xml";